import { useEffect, useRef } from 'react'

export function useMountedRef() {
  const mounted = useRef(false)

  // lifecycle integration
  useEffect(() => {
    mounted.current = true
    return () => {
      mounted.current = false
    }
  }, [])

  return mounted
}

export function usePrevious<T>(value: T) {
  // oxlint-disable-next-line typescript/no-unnecessary-type-arguments
  const ref = useRef<T>(value)

  useEffect(() => {
    ref.current = value
  }, [value])

  // oxlint-disable-next-line rc/refs
  return ref.current
}
